import React, { useEffect, useState } from "react";
import ToolkitProvider from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import BootstrapTable from "react-bootstrap-table-next";
import { Col, Row, Card, CardBody, Label } from "reactstrap";
import { useLocation } from "react-router-dom";
import CustomPagination from "../../../components/CommonComponents/Pagination";
import { cyanBlue } from "../constants/Constants";
import { getEmailConfigList } from "action/plans";
import { useDispatch, useSelector } from "react-redux";
import { GetEmailConfigList } from "constants/ReducerConstants/Constants";

function EmailConfiguration() {
  const location = useLocation();
  const id = location.state?.id;
  const [pageNum, setPageNum] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(false);

  const dispatch = useDispatch();
  const emailConfigData = useSelector(
    (state) => state.TenantDetailsReducer.emailConfigList
  );

  useEffect(() => {
    dispatch({ type: GetEmailConfigList, payload: {} });
    getEmailConfigList(dispatch, id);
  }, [dispatch]);

  useEffect(() => {
    if (emailConfigData?.code) {
      if (emailConfigData?.code === 200) {
        setError(false);
        setIsLoading(false);
      } else {
        setError(true);
        setIsLoading(false);
      }
    } else {
      setError(false);
      setIsLoading(true);
    }
  }, [emailConfigData]);
  const columns = [
    { dataField: "ID", text: "ID" },
    {
      dataField: "MailingService",
      text: "Mailing Service",
      sort: true,
      formatter: (cell) =>
        cell === "" ? <div className="text-center">-</div> : cell,
    },
    {
      dataField: "Title",
      text: "Title",
      sort: true,
      formatter: (cell) =>
        cell === "" ? <div className="text-center">-</div> : cell,
    },
    {
      dataField: "senderEmail",
      text: "sender Email",
      sort: true,
      formatter: (cell) =>
        cell === "" ? <div className="text-center">-</div> : cell,
    },
    {
      dataField: "ConfigType",
      text: "Config Type",
      sort: true,
      formatter: (cell) =>
        cell === "" ? <div className="text-center">-</div> : cell,
    },
    {
      dataField: "CreatedBy",
      text: "Created By",
      sort: true,
      formatter: (cell) =>
        cell === "" ? <div className="text-center">-</div> : cell,
    },
    {
      dataField: "CreatedOn",
      text: "Created On",
      sort: true,
      formatter: (cell) =>
        cell === "" ? <div className="text-center">-</div> : cell,
    },
  ];

  return (
    <>
      <Card style={style.cardStyle}>
        <CardBody>
          <Col lg="12" md="12" sm="12">
            <Col lg="12" md="12" sm="12">
              <Row className=" d-flex justify-content-between">
                <Label className="h3">Email Configuration</Label>
              </Row>
              <Row lg="12" md="12" sm="12">
                {isLoading ? (
                  <div style={style.loaderContainer}>
                    <i
                      className="fa fa-spinner fa-spin fa-2xl"
                      style={style.loaderColor}
                    />
                  </div>
                ) : error ? (
                  <>
                    <div style={style.loaderContainer}>
                      Something went wrong
                    </div>
                  </>
                ) : (
                  <>
                    {emailConfigData?.data?.totalRecords ? (
                      <ToolkitProvider
                        data={emailConfigData.data.EmailConfigurations}
                        keyField="ID"
                        columns={columns}
                        headerAlign="center"
                        search>
                        {(props) => (
                          <div className="py-4 table-responsive">
                            <BootstrapTable
                              {...props.baseProps}
                              bootstrap4={true}
                              bordered={false}
                            />
                          </div>
                        )}
                      </ToolkitProvider>
                    ) : (
                      <div style={style.loaderContainer}>
                        <p style={style.loaderText}>No Record Found</p>
                      </div>
                    )}
                  </>
                )}
              </Row>
            </Col>
            <CustomPagination
              totalPages={Math.ceil(
                emailConfigData?.data?.totalRecords /
                  emailConfigData?.data?.noOfRecordsPerPage
              )}
              setPageNum={setPageNum}
              activePage={pageNum}
            />
          </Col>
        </CardBody>
      </Card>
    </>
  );
}

export default EmailConfiguration;

const style = {
  loaderColor: { color: cyanBlue },
  loaderContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "10vh",
    width: "100%",
  },
  loaderText: {
    margin: "auto",
    fontWeight: "normal",
  },
  cardStyle: { marginLeft: "0.4rem", marginRight: "0.4rem" },
};
